<!-- Селект типа ресурса для фильтрации журнала событий. Список загружается с бэкенда -->
<template>
  <BaseSelect
    :options="store.availableResources"
    :model-value="modelValue"
    placeholder="Все ресурсы"
    :clearable="true"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script>
import { useActivityLogStore } from "@/stores/activityLogStore";

export default {
  name: "ActivityLogResourceSelect",

  props: {
    modelValue: {
      type: String,
      default: null,
    },
  },

  emits: ["update:modelValue"],

  computed: {
    store() {
      return useActivityLogStore();
    },
  },
};
</script>
